import React from "react";
import { useLang } from "../context/LanguageContext";
import { contactInfo } from "../mock";
import { Shield, Mail, Phone, MessageCircle } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  const f = t.footer;

  return (
    <footer className="bg-[#081527] border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-white/10 border border-white/15">
                <Shield className="w-5 h-5 text-[#f5871f]" />
              </span>
              <span className="font-display font-700 text-white text-xl">GRUPO <span className="text-[#f5871f]">RPC</span></span>
            </div>
            <p className="mt-4 text-white/50 text-sm leading-relaxed">{f.tagline}</p>
          </div>

          <div>
            <h4 className="font-display font-700 text-white uppercase text-sm tracking-wider">{f.servicesTitle}</h4>
            <ul className="mt-4 space-y-2">
              {f.services.map((s, i) => (
                <li key={i} className="text-white/50 text-sm hover:text-[#f5871f] transition-colors cursor-default">{s}</li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-700 text-white uppercase text-sm tracking-wider">{f.companyTitle}</h4>
            <ul className="mt-4 space-y-2">
              {["#servicios", "#empresas", "#aseo", "#monitoreo", "#contacto"].map((href, i) => (
                <li key={i}>
                  <a href={href} className="text-white/50 text-sm hover:text-[#f5871f] transition-colors">{f.links[i]}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-700 text-white uppercase text-sm tracking-wider">{f.contactTitle}</h4>
            <ul className="mt-4 space-y-3">
              <li><a href={`mailto:${contactInfo.email}`} className="flex items-center gap-2 text-white/50 text-sm hover:text-[#f5871f] transition-colors"><Mail className="w-4 h-4" />{contactInfo.email}</a></li>
              <li><a href={contactInfo.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-white/50 text-sm hover:text-[#f5871f] transition-colors"><MessageCircle className="w-4 h-4" />{contactInfo.phone}</a></li>
              <li><a href={`tel:+${contactInfo.phoneRaw}`} className="flex items-center gap-2 text-white/50 text-sm hover:text-[#f5871f] transition-colors"><Phone className="w-4 h-4" />{contactInfo.phone}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">© {new Date().getFullYear()} Grupo RPC. {f.rights}</p>
          <p className="text-white/30 text-xs">RPC Seguridad · RPC Limpieza Industrial · Serviram Seguridad</p>
        </div>
      </div>
    </footer>
  );
}
